package dev.danko.roblox_craft_ai.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import dev.danko.roblox_craft_ai.client.RobloxCraftApiClient
import com.varabyte.kobweb.core.rememberPageContext
import dev.danko.roblox_craft_ai.state.AuthState
import dev.danko.roblox_craft_ai.uikit.components.AppButton
import dev.danko.roblox_craft_ai.uikit.components.AppButtonSize
import dev.danko.roblox_craft_ai.uikit.components.AppButtonVariant
import dev.danko.roblox_craft_ai.uikit.components.LoginDialog
import dev.danko.roblox_craft_ai.uikit.components.ToastManager
import dev.danko.roblox_craft_ai.uikit.i18n.LocaleController
import dev.danko.roblox_craft_ai.uikit.i18n.strings
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent

/** Mounted once at the app root: loads the auth state and hosts the sign-in dialog for every page. */
@Composable
fun AuthHost() {
    val scope = rememberCoroutineScope()
    LaunchedEffect(Unit) { AuthState.init() }
    LoginDialog(
        visible = AuthState.loginDialogOpen,
        onDismiss = { AuthState.loginDialogOpen = false },
        onSend = { email -> RobloxCraftApiClient.requestMagicLink(email, LocaleController.current.code) },
        launch = { block -> scope.launch { block() } },
        legalLinks = { LegalLinks(listOf(LegalDoc.TERMS, LegalDoc.PRIVACY), Modifier.fontSize(0.8.cssRem)) }
    )
}
